import React from 'react';
import { Avatar, Badge } from 'components/ui';
import useUserStore from 'store/useUserStore';
import { resolveSclaApplication } from 'utils/sclaApplicationKind';
import styles from './SidebarUserCard.module.scss';

export default function SidebarUserCard() {
  const user = useUserStore(s => s.user);
  if (!user) return null;

  const displayName =
    `${user.firstName ?? ''} ${user.lastName ?? ''}`.trim() ||
    user.name ||
    'TXTer';
  const txter = resolveSclaApplication(user.type).kind === 'returner';

  return (
    <div className={styles.card}>
      <Avatar
        size={48}
        src={user.profileImage}
        firstName={user.firstName}
        lastName={user.lastName}
        name={displayName}
      />
      <div className={styles.meta}>
        <p className={styles.name}>{displayName}</p>
        {txter ? <Badge tone="brand">TXTer</Badge> : null}
      </div>
    </div>
  );
}
